import {useEffect, useRef} from "react";

/**
 * Returns previous value of some prop / state. e.g. prevProps / prevState in class based components
 * @param value
 * @param updateOnChangeArray
 * @return {undefined}
 */
export default function usePrevious<T>(value: T, updateOnChangeArray: any[] = undefined): T {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    }, updateOnChangeArray);
    return ref.current;
}